<ng-container *ngFor="let label of offer.labels">
  <span class="label label--lowest-price" *ngIf="label === 'Najniższa cena'">NAJNIŻSZA CENA</span>
  <span class="label label--highest-discount" *ngIf="label === 'Największy rabat' && brand.slug !== 'alfa-romeo'">% NAJWIĘKSZY RABAT %</span>
  <span class="label label--leasing" *ngIf="label === 'Leasing100'">LEASING <strong>100%</strong></span>
  <span class="label label--wolnosc-wyboru"
        *ngIf="!isProd && label === 'WolnoscWyboru' && offer.leasing_installment && offer.leasing_installment !== null && offer.leasing_installment > 0">
      <strong>Wolność Wyboru: od&nbsp;<strong>{{offer.leasing_installment | formatMoney}}</strong>&nbsp;zł&nbsp;netto/mies.</strong></span>
</ng-container>
<ng-container *ngIf="brand.slug === 'alfa-romeo' && getPercentDiscount() > 0">
  <span class="label label--alfa-201911"><strong>RABAT {{getPercentDiscount()}}%</strong></span>
</ng-container>
